import { lazy } from 'react'

export const ProfileSettingsPage = lazy(() => import('./Profile'))